import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import {
  PendingUnitCommand,
  pendingUnitCommandSchema,
} from '@sophocles/entities/PendingUnitCommand/pendingUnitCommandRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_PENDING_UNIT_COMMANDS = 'RECEIVE_PENDING_UNIT_COMMANDS';
export function receivePendingUnitCommands(json) {
  return {
    type: RECEIVE_PENDING_UNIT_COMMANDS,
    pendingUnitCommands: mapListToRecords(json, PendingUnitCommand),
  };
}

export const RECEIVE_AND_WIPE_PENDING_UNIT_COMMANDS = 'RECEIVE_AND_WIPE_PENDING_UNIT_COMMANDS';
export function receiveAndWipePendingUnitCommands(json) {
  return {
    type: RECEIVE_AND_WIPE_PENDING_UNIT_COMMANDS,
    pendingUnitCommands: mapListToRecords(json, PendingUnitCommand),
  };
}

/* Request Actions */
// starter request
export const REQUEST_PENDING_UNIT_COMMAND = 'REQUEST_PENDING_UNIT_COMMAND';
function requestPendingUnitCommand(pendingUnitCommand_id) {
  return {
    type: REQUEST_PENDING_UNIT_COMMAND,
    pendingUnitCommand_id,
  };
}

export const REQUEST_PENDING_UNIT_COMMANDS_FOR_SITE = 'REQUEST_PENDING_UNIT_COMMANDS_FOR_SITE';
function requestPendingUnitCommandsForSite(site_id) {
  return {
    type: REQUEST_PENDING_UNIT_COMMANDS_FOR_SITE,
    site_id,
  };
}

export const MARK_PENDING_COMMANDS_AS_COMPLETED = 'MARK_PENDING_COMMANDS_AS_COMPLETED';
export function markPendingCommandsAsCompleted(commands) {
  return {
    type: MARK_PENDING_COMMANDS_AS_COMPLETED,
    commands,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchPendingUnitCommand(pendingUnitCommand_id) {
  return dispatch => {
    dispatch(requestPendingUnitCommand(pendingUnitCommand_id));
    return apiClient
      .get(`/pendingcommands/${pendingUnitCommand_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'pendingUnitCommands', pendingUnitCommandSchema))
      .then(json => dispatch(receivePendingUnitCommands(json.entities.pendingUnitCommands)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_PENDING_UNIT_COMMAND));
      });
  };
}

export function fetchPendingUnitCommandsForSite(site_id) {
  return dispatch => {
    dispatch(requestPendingUnitCommandsForSite(site_id));
    return apiClient
      .get('/pendingcommands/', { params: { site: site_id } })
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'pendingUnitCommands', pendingUnitCommandSchema))
      .then(json => dispatch(receiveAndWipePendingUnitCommands(json.entities.pendingUnitCommands)))
      .catch(error => {
        dispatch(genericErrorAction(error, REQUEST_PENDING_UNIT_COMMAND));
      });
  };
}

/* Edit Actions */
export const EDIT_PENDING_UNIT_COMMAND = 'EDIT_PENDING_UNIT_COMMAND';
export function editPendingUnitCommand(pendingUnitCommand_id) {
  return {
    type: EDIT_PENDING_UNIT_COMMAND,
    pendingUnitCommand: pendingUnitCommand_id,
  };
}

export function patchPendingUnitCommand(pendingUnitCommand_id, values) {
  return dispatch => {
    dispatch(editPendingUnitCommand(pendingUnitCommand_id));
    return apiClient
      .patch(`/pendingcommands/${pendingUnitCommand_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, pendingUnitCommandSchema))
      .then(json => {
        dispatch(receivePendingUnitCommands(json.entities.pendingUnitCommands));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, EDIT_PENDING_UNIT_COMMAND));
      });
  };
}

/* Create Actions */
export const CREATE_PENDING_UNIT_COMMAND = 'CREATE_PENDING_UNIT_COMMAND';
function sayCreatePendingUnitCommand(values) {
  return {
    type: CREATE_PENDING_UNIT_COMMAND,
    values: values,
  };
}

export function createPendingUnitCommand(values) {
  return dispatch => {
    dispatch(sayCreatePendingUnitCommand(values));
    return apiClient
      .post(`/pendingcommands/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, pendingUnitCommandSchema))
      .then(json => {
        dispatch(receivePendingUnitCommands(json.entities.pendingUnitCommands));
      })
      .catch(error => {
        dispatch(genericErrorAction(error, CREATE_PENDING_UNIT_COMMAND));
      });
  };
}

/* Delete Actions */
export const DELETE_PENDING_UNIT_COMMAND = 'DELETE_PENDING_UNIT_COMMAND';
function sayDeletePendingUnitCommand(pendingUnitCommand_id) {
  return {
    type: DELETE_PENDING_UNIT_COMMAND,
    pendingUnitCommand: pendingUnitCommand_id,
  };
}

export function deletePendingUnitCommand(pendingUnitCommand_id) {
  return dispatch =>
    apiClient
      .delete(`/pendingcommands/${pendingUnitCommand_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeletePendingUnitCommand(pendingUnitCommand_id)))
      .catch(error => {
        dispatch(genericErrorAction(error, DELETE_PENDING_UNIT_COMMAND));
      });
}

const receiver = (dispatch, json) => dispatch(receivePendingUnitCommands(json.entities.pendingUnitCommands));

export const handlePendingUnitCommandsSocketActions = websocketsHandlerFactory(
  receiver,
  sayDeletePendingUnitCommand,
  pendingUnitCommandSchema,
);
